import React, {useEffect, useState} from 'react';
import {LessonItem} from "./lesson-item/LessonItem";
import {PeriodCalendar} from "./period-calendar/Period-calendar";
import './style.css'
import {useAppDispatch, useAppSelector} from "common/hook";
import {useParams} from "react-router-dom";
import {
    fetchLessonsByGroupsId
} from "features/model/service/groups/groups-lessons/fetchLessonsByGroupsId";
import {CustomPagination} from "components/pagination/CustomPagination";
import {fetchLessonsId} from "features/model/service/groups/lessons/fetchLessonsId";
import {fetchCalendar} from "features/model/service/calendar/calendar";




export const MainTable: React.FC = () => {
    const dispatch = useAppDispatch()
    const paginationData = useAppSelector((state) => state.groupsLessons.pagination);
    const {page, pageSize, pageCount} = paginationData;
    const [currentPage, setCurrentPage] = useState<number>(1);
    const [currentFrom, setCurrentFrom] = useState<string>('');
    const [currentTo, setCurrentTo] = useState<string>('');
    const {groupId} = useParams();
    const from = useAppSelector((state) => state.date.dateWith);
    const to = useAppSelector((state) => state.date.dateTo);


    const onChangeHandle = (event: React.ChangeEvent<unknown>, value: number) => {
        setCurrentPage(value);
        dispatch(fetchLessonsByGroupsId({
            groupId,
            page: value - 1,
            from: from,
            to: to
        }));
    };

    // useEffect(() => {
    //     if(groupId) {
    //         dispatch(fetchCalendar({groupId}));
    //     }
    // }, []);


    return (
        <>
            <PeriodCalendar create={true} print={false} setCurrentFrom={setCurrentFrom} setCurrentTo={setCurrentTo}  />
            <div className="data-tbl inner-group-lesson-tbl data-tbl-border data-tbl-padding">
                <div className="row thead">
                    <div className="col lesson-col">Занятие</div>
                    <div className="col status-col">Статус</div>
                    <div className="col lesson-time-col">Время занятия</div>
                    <div className="col btn-col"></div>
                </div>
                <LessonItem currentPage={currentPage} currentFrom={currentFrom} currentTo={currentTo}/>
            </div>
            {pageCount > 1 && (
                <CustomPagination pageCount={pageCount} onChangeHandle={onChangeHandle} />
            )}
        </>
    );
};

